<template>
  <fragment>
    <content-block
      v-for="page in structureData.pages" :key="page.guid" :guid="page.guid"
      :block-props="page.blockProps" :children="page.children"
      :behaviour-type="page.behaviourType"
    />
    <initial-recommendation-block
      v-if="Object.keys(initialRecommendationStructure).length !== 0"
      v-bind="initialRecommendationStructure"
      :visible="visible"
    />
    <banner-recommendation-block
      v-if="Object.keys(bannerRecommendationStructure).length !== 0"
      v-bind="bannerRecommendationStructure"
      :visible="visible"
    />
    <banner-shop-block
      v-if="Object.keys(bannerShopStructure).length !== 0"
      v-bind="bannerShopStructure"
      :visible="visible"
    />
  </fragment>
</template>

<script>
import { mapActions } from 'vuex';
import { loadFont } from '@core/helpers/fonts';
import InitialRecommendationBlock from './components/InitialRecommendationBlock.vue';
import BannerRecommendationBlock from './components/BannerRecommendationBlock.vue';
import BannerShopBlock from './components/BannerShopBlock.vue';
import ContentBlock from './components/ContentBlock.vue';

export default {
  name: 'menu-render',
  components: { ContentBlock, InitialRecommendationBlock, BannerRecommendationBlock, BannerShopBlock },
  props: {
    structureData: { type: Object, default: () => ({ pages: [], meta: { fonts: [] } }) },
    pricesData: { type: Object, default: () => ({}) },
    userDefinedData: { type: Object, default: () => ({}) },
    zoneOfConsume: { type: String, required: true },
    tableGuid: { type: String },
    initialRecommendationStructure: { type: Object, default: () => ({}) },
    bannerRecommendationStructure: { type: Object, default: () => ({}) },
    bannerShopStructure: { type: Object, default: () => ({}) }
  },
  async created() {
    await this.applyFonts(this.structureData.meta?.fonts);
    await this.setSelectedLanguage(this.structureData.defaultLanguage);
    await this.setSelectedZoneOfConsume(this.zoneOfConsume);
    await this.setPrices(this.pricesData);
    await this.setUserDefinedData(this.userDefinedData);
    await this.setCurrencySymbol(this.structureData.currency);
    await this.setCurrencyPosition(this.structureData.currencyPosition);
    await this.setShowFeatures(this.structureData.defaultAllergensStatus);
    await this.setShowIconFeatures(this.structureData.useIconInProductFeatures);
    await this.setShowProductTags(this.structureData.displayProductTags);
    await this.setShowIconProductTags(this.structureData.displayProductTagsUsingIcons);
    await this.setTableGuid(this.tableGuid);
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    ...mapActions([
      'setSelectedLanguage', 'setSelectedZoneOfConsume', 'setPrices', 'setShowProductTags',
      'setUserDefinedData', 'setCurrencySymbol', 'setCurrencyPosition', 'setShowFeatures',
      'setShowIconFeatures', 'setShowIconProductTags', 'setTableGuid'
    ]),
    async applyFonts(fonts = []) {
      for (let i = 0; i < fonts.length; i += 1) {
        const { fontFamily, url } = fonts[i];
        await loadFont(fontFamily, url);
      }
    }
  }
};
</script>
